export default "/fonts/vendor/simple-line-icons/Simple-Line-Icons.woff?5c9febce52054ae0b96ddd3e2d173e1a";